/**
 * Temporary launch banners. Flip a banner's `enabled` flag to false (or delete
 * the entry) to retire it. Removal trigger phrase: "remove qubetics solver
 * launch banners".
 *
 * Current banners
 *  - qubeticsSolver: scheduled removal on 2026-06-22 (two weeks from 2026-06-08).
 */

export interface LaunchBanner {
  enabled: boolean;
  /** Short eyebrow shown before the headline (e.g. "New", "Just launched"). */
  eyebrow: string;
  /** Single-line headline shown in the top bar. */
  headline: string;
  /** Optional mobile-only shortened headline (no truncation needed). */
  headlineShort?: string;
  /** Link target for both the bar and the services-grid ribbon. */
  href: string;
  /** Label for the services-grid corner ribbon. */
  ribbonLabel: string;
  /** Services-grid card slug to attach the ribbon to (matches title). */
  ribbonTarget: string;
}

export const LAUNCH_BANNERS = {
  qubeticsSolver: {
    enabled: false,
    eyebrow: "New",
    headline:
      "Qubetics Solver Node is live in One-Click Nodes. Set up in minutes.",
    headlineShort: "Qubetics Solver Node is live in One-Click Nodes.",
    href: "/blogs/qubetics-solver-node-setup-guide",
    ribbonLabel: "New launch",
    ribbonTarget: "Node as a Service",
  },
} as const satisfies Record<string, LaunchBanner>;

export type LaunchBannerKey = keyof typeof LAUNCH_BANNERS;
